// sessionSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SessionState {
  isLoggedIn: boolean;
  user_id: string | null;
  user_name: string | null;
  session_id: string | null;
  original_session_id: string | null; // Keep original session for voice operations
}

// interface UserState {
//   id: string;
//   user_name: string | null; 
//   email: string | null;
// }

const initialState: SessionState = {
  isLoggedIn: false,
  user_id: null,
  user_name: null,
  session_id: null,
  original_session_id: null,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setLoginState: (state, action: PayloadAction<{ isLoggedIn: boolean; id: string }>) => {
      state.isLoggedIn = action.payload.isLoggedIn;
      state.user_id = action.payload.id;
    },
    setUser: (
      state,
      action: PayloadAction<{ id: string; user_name: string | null; email: string | null } | null>
    ) => {
      if (action.payload) {
        state.user_id = action.payload.id;
        state.user_name = action.payload.user_name;
        state.isLoggedIn = true;
      } else {
        state.user_id = null;
        state.user_name = null;
        state.isLoggedIn = false;
      }
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user_id = null;
      state.user_name = null;
      state.session_id = null;
      state.original_session_id = null;
    },
    setSessionId: (state, action: PayloadAction<string | null>) => {
      state.session_id = action.payload;
    },
    setOriginalSessionId: (state, action: PayloadAction<string | null>) => {
      state.original_session_id = action.payload;
      // If this is the first time setting original session, also set session_id
      if (action.payload && !state.session_id) {
        state.session_id = action.payload;
      }
    },
  },
});

export const { setLoginState, setUser, logout, setSessionId, setOriginalSessionId } = sessionSlice.actions;

// Rename selector from selectRunId to selectSessionId
export const selectUserId = (state: { session: SessionState }) => state.session.user_id;
export const selectUserName = (state: { session: SessionState }) => state.session.user_name;
export const selectSessionId = (state: { session: SessionState }) => state.session.session_id;
export const selectOriginalSessionId = (state: { session: SessionState }) => state.session.original_session_id;
export const selectIsLoggedIn = (state: { session: SessionState }) => state.session.isLoggedIn;

export default sessionSlice.reducer;